import { Screen } from '@accounts/navigation';
import { usePresence } from '@accounts/session';
import { Invitations } from './home/invitations';

/**
 * The invitations addressed to this person, to accept or decline (ARR-03)
 */
export function Received() {
	const { text } = usePresence();
	return (
		<Screen template="settings" title={text('received.title')}>
			<Invitations always />
		</Screen>
	);
}
